import React, { useState, useEffect } from 'react';
import { FaUser, FaClock, FaBrain, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { APIURL } from "../../../Global";
import axios from "axios";
import './AssessmentHistory.css'
import { useAlert } from 'react-alert';
import ReAssessment from './ReAssessment';

const ReAssessmentDashboard = ({ assessment_id, patientData, type }) => {
    const [assessments, setAssessments] = useState([]);
    const [selectedAssessment, setSelectedAssessment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState('history');
    const alert = useAlert();
    
    useEffect(() => {
        fetchAssessments();
    }, []);

    useEffect(() => {
        console.log(selectedAssessment)
    }, [selectedAssessment])

    const fetchAssessments = async () => {
        try {
            setLoading(true);
            const tokenString = sessionStorage.getItem("usertoken");
            let v2 = tokenString.replace(/["]+/g, "");

            const response = await axios.get(`${APIURL}/api/v1/patient/therapy-assessment/?assessment_id=${assessment_id}&assessment_type=${type || 'general'}&assessment_form=reassess`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Token " + v2,
                },
            });

            if (response.data.status === 'success') {
                const newAssessments = response.data.message.slice().reverse();
                setAssessments(newAssessments);

                // Update selected assessment if it exists in the new data
                if (selectedAssessment) {
                    const updatedSelectedAssessment = newAssessments.find(
                        assessment => assessment.id === selectedAssessment.id
                    );

                    if (updatedSelectedAssessment) {
                        setSelectedAssessment(updatedSelectedAssessment);
                    } else {
                        // If selected assessment no longer exists, clear selection
                        setSelectedAssessment(null);
                        setShow('history');
                    }
                }
            } else {
                alert.error(response.data.message || 'Error Occurred')
            }
        } catch (err) {
            console.error('Error fetching assessments:', err);
            alert.error('Failed to fetch assessments');
        } finally {
            setLoading(false);
        }
    };

    const handleReassessmentClick = () => {
        setShow('re-assessment');
        setSelectedAssessment(null); // Clear selection when adding new assessment
    };

    const handleAssessmentSelect = (assessment) => {
        setSelectedAssessment(assessment);
        setShow('history'); // Ensure we're in history/read-only mode
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-content">
                    <div className="spinner"></div>
                    <p>Loading assessments...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="assessment-history" style={{ padding: 0 }}>
            <div className="header-section" style={{ margin: 0 }}>
                <button
                    className="new-assessment-btn"
                    onClick={handleReassessmentClick}
                    disabled={patientData.appt}
                    style={{ 
                        backgroundColor: show === 're-assessment' ? '#1d4fd8b5' : '', 
                        width: '15%', 
                        margin: '-115px 0 0 auto' 
                    }}
                >
                    <FaPlus className="btn-icon" />
                    Re-assessment
                </button>
            </div>
            
            <div className="main-content">
                <div className="history-view">
                    {/* Fixed Assessment List */}
                    <div className="assessment-list-section col-3">
                        <div className="list-container">
                            <div className="list-header">
                                <h2>Available Assessments</h2>
                                <p>{assessments.length} re-assessments</p>
                            </div>

                            <div className="list-content">
                                {assessments.length === 0 ? (
                                    <div className="empty-message">
                                       Unable to load assessments or No assessments found
                                    </div>
                                ) : (
                                    assessments.map((assessment, index) => (
                                        <div
                                            key={assessment.id || index}
                                            onClick={() => handleAssessmentSelect(assessment)}
                                            className={`assessment-item ${
                                                selectedAssessment?.id === assessment.id && show === 'history' ? 'selected' : ''
                                            }`}
                                        >
                                            <div className="item-content">
                                                <div className="item-details">
                                                    {assessment.created_at && (
                                                        <p className="item-date">
                                                            {formatDate(assessment.created_at)}
                                                        </p>
                                                    )}
                                                    {assessment.description && (
                                                        <p className="item-description">
                                                            {assessment.description}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="item-arrow">›</div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Dynamic Details Section */}
                    <div className="assessment-details-section col-9">
                        <div className="details-container">
                            {show === 're-assessment' ? (
                                <ReAssessment 
                                    assessment_id={assessment_id} 
                                    data={patientData} 
                                    show='post' 
                                    type={type} 
                                    onSubmit={fetchAssessments} 
                                />
                            ) : selectedAssessment ? (
                                <ReAssessment 
                                    assessment_id={assessment_id} 
                                    data={patientData} 
                                    show='readOnly'
                                    selectedAssessment={selectedAssessment}
                                    type={type}
                                />
                            ) : (
                                <div className="empty-selection">
                                    <div className="empty-content">
                                        <p className="empty-title">Select an assessment to view details</p>
                                        <p className="empty-subtitle">Choose from the list on the left</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReAssessmentDashboard;